import CreateAxiosInstance from './axiosConfig';
const APIClient = CreateAxiosInstance(import.meta.env.VITE_API_BASE_URL);

export function saveUserSettings(settings) {
  // Settings will be saved as long as they do not equal None
  return APIClient.post(`/user/settings`, settings);
}
export function getUserSettings() {
  return APIClient.get(`/user/settings`);
}

export function subscribeToMailerlite() {
  return APIClient.post(`/user/subscribe_to_mailerlite`);
}
